import axios from 'axios'
import qs from 'qs'//yarn add qs
import { scope,client_id,redirect_uri } from './constants'

export function generateAuthUrl() {
	return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_uri}&scope=${scope}`;
}

export async function  getClient(context){
    try{    
        //context.commit('setLoading',true,{root:true})
        //let url = "/oauth20_authorize.srf"       
        //let url =`common/oauth2/v2.0/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_uri}&scope=${scope}`
        let url  = `common/adminconsent?client_id=${client_id}&state=bollogin&redirect_uri=${redirect_uri}`
        /*let params = {
            client_id : '12d94487-fe0b-480c-9c11-5e71f3e47323',
            scope : 'files.read',
            redirect_uri:'http://localhost',
            response_type: 'token'
        }*/
        
        //let config = { "Authorization": "Bearer " + data.jwt    }
        let  config ={
            //'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*'
        }      
        let reqOptions = {
            method: 'GET',
            url: url,
            baseURL: 'https://login.microsoftonline.com/',
            //headers: config,
            //params: params,
            //paramsSerializer: function (params) {                return qs.stringify(params,{ arrayFormat: brackets' })
        }//reqOptions 
        
        const response  = await axios.request(reqOptions)
        //console.log(response.request._redirectable._redirectCount)
        console.log(response)
        context.commit('setVars',response.data)  
       
      }catch(error){
        if (error.response){
          context.commit('onedriveError', error.response)
        
         }
          
      }finally{
        //context.commit('setLoading',false,{root:true})
      } 
}

export function Authorization(){

}//authorization